import { useMemo, useState } from 'react';

export function useRegexSearch() {
  const [search, setSearch] = useState('');
  const regexSearch = useMemo(() => {
    try {
      return RegExp(`.*${search.toLowerCase()}.*`);
    } catch {
      return RegExp(`.*.*`);
    }
  }, [search]);

  return { search, setSearch, regexSearch };
}
